import { Alignment, FontIcon, Stack } from "@fluentui/react"
import { FunctionComponent } from "react"
import { helperFont } from "../../utils/helpers/helpers"
import COLORES from "../../utils/theme/colores"
import themeBase from "../../utils/theme/themeBase"

interface HeaderTableProps {
    hidenIcon?: Boolean
    title: string
    subTitle?: string
    showSubTitle?: Boolean
    iconName?: string
    horizontalAlign?: Alignment
}

const Initial_Header: HeaderTableProps = {
    title: "Titulo",
    hidenIcon: false,
    iconName: "Dialpad",
    showSubTitle: true,
    horizontalAlign: "start"
}

const HeaderTable: FunctionComponent<HeaderTableProps> = (props = Initial_Header) => {
    const PositionT = () => {
        if (!props.hidenIcon)
            switch (props.horizontalAlign) {
                case "start": return <>{props.title}</>
                case "end": return <>{props.title}</>
                default: return <>{props.title}</>
            }
        else
            return <> <span>{props.title}</span>  </>
    }
    return (
        <>
            <Stack
                style={{ ...helperFont, color: COLORES.Bases.neutralSecondaryAlt, }} verticalAlign="center" horizontal horizontalAlign={props.horizontalAlign}>
                {/* <FontIcon iconName={props.iconName} className="ms-fontWeight-bold" /> */}
                {PositionT()}
            </Stack>
            <Stack style={{ ...helperFont, fontSize: '14px', color: COLORES.Bases.neutralSecondaryAlt, }} horizontal horizontalAlign={props.horizontalAlign}>
                <span>{props.subTitle}</span>
            </Stack>
        </>
    );
}

export default HeaderTable;